<template>
  <div class="tab-container" :class="{ loading }">
    <div ref="tabWrapper" class="tab-wrapper">
      <div
        class="slider-bg"
        :style="sliderStyle"
      />
      <router-link
        v-for="({ label, route: tabRoute }) in tabs"
        :key="label"
        :to="{ name: tabRoute }"
        class="tab"
      >
        {{ label }}
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useRoute } from 'vue-router';

defineProps({
  tabs: {
    type: Array,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const sliderWidth = ref(0);
const sliderLeft = ref(0);

const tabWrapper = ref(null);

const route = useRoute();

const updateSlider = () => {
  const el = tabWrapper.value?.querySelector('.router-link-active');

  if (el) {
    const rect = el.getBoundingClientRect();
    const parentRect = el.parentElement.getBoundingClientRect();

    sliderLeft.value = `${rect.left - parentRect.left}px`;
    sliderWidth.value = `${rect.width}px`;
  }
};

const sliderStyle = computed(() => ({
  left: sliderLeft.value,
  width: sliderWidth.value,
}));

watch(
  () => route.name,
  async () => {
    setTimeout(() => {
      updateSlider();
    }, 500);
  },
  { immediate: true },
);
</script>

<style lang="less" scoped>
.tab-container {
  display: flex;
  justify-content: flex-start;

  &.loading {
    pointer-events: none;
    opacity: 0.4;
  }
}

.tab-wrapper {
  position: relative;
  background-color: @white;
  border-radius: 48px;
  padding: 6px;
  display: flex;
  align-items: center;
  gap: 16px;
  overflow: hidden;
  border: 1px solid @stroke-default;
}

.slider-bg {
  position: absolute;
  top: 6px;
  bottom: 6px;
  border-radius: 32px;
  background-color: @bg-canvas;
  transition: all 0.3s ease;
  z-index: 0;
}

.tab {
  position: relative;
  padding: 8px;
  border-radius: 32px;
  cursor: pointer;
  color: @text-light;
  white-space: nowrap;
  font-weight: 500;
  font-size: 13px;
  transition: color 0.3s ease;

  &.router-link-active {
    color: @text-brand;
  }
}
</style>
